function getCsrfToken() {
	fetch('/csrf-token')
		.then(response => response.text())
		.then(token => setCsrfToken(token));
}

function setCsrfToken(token) {
	if (token.length == 0) return;

	$.ajaxSetup({
		headers: {
			'X-CSRF-TOKEN': token
		}
	});
	$('[name="csrf"]').attr('content', token);
	$('input[name=_token]').val(token);
}

$(() => {
	const token = $('[name="csrf"]').attr('content');
	setCsrfToken(token);

	idle({
		onActive: getCsrfToken,
		onShow: getCsrfToken,
		idle: 10000,
	}).start();
});
